import { useMemo } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useSelector } from 'react-redux';

/**
 * Collect the customer id from different sources as none of them are consistent.
 */
export const useCustomerId = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const app = useSelector(state => (state as any).application);
  const { user } = useAuth0();
  const customerId = useMemo(() => {
    const customerIdFromApp: string | null = app && app.customerId !== '0'
      ? app.customerId
      : null;
    const customerIdFromAuth0: string | null = user && user.kueski_user_id
      ? user.kueski_user_id
      : null;

    return customerIdFromAuth0 || customerIdFromApp || null;
  }, [app?.customerId, user?.kueski_user_id]);

  return customerId;
};
